import { Controller } from "@hotwired/stimulus"

// Shows a column's format field only while its data type is the one a format
// applies to (date/time). The server renders the same state, so this only has
// to keep up with a not-yet-saved type change; a freshly connected field is
// toggled on connect so the row is never left showing a stale field.
export default class extends Controller {
  static targets = ["select", "field"]
  static values = { formatted: String }

  selectTargetConnected() {
    this.refresh()
  }

  fieldTargetConnected(field) {
    this.toggle(field)
  }

  refresh() {
    this.fieldTargets.forEach((field) => this.toggle(field))
  }

  toggle(field) {
    if (!this.hasSelectTarget) return

    field.hidden = this.selectTarget.value !== this.formattedValue
  }
}
